import { FC } from "react"
import { ActivityTableRow } from "../../../../../types"
import ActivityCard from "../../card"

interface Props {
  info: ActivityTableRow
  isBrandActivity?: boolean
}

const DescriptionCell: FC<Props> = ({ info, isBrandActivity }) => (
  <td className="py-0 px-0" colSpan={3}>
    <ActivityCard
      activity={info}
      member={info.detail?.lo}
      isLoActivity={info.isLoActivity}
      isBrandActivity={isBrandActivity}
    />
  </td>
)

export default DescriptionCell
